import { AuthService } from "src/app/services/auth.service";
import { CommonMethods } from "src/app/services/common.method";
import { CommonService } from "@shared/services/common";
import { Component, OnInit, ElementRef, ViewChild, NgZone, AfterViewInit, ViewContainerRef, Input } from "@angular/core";
import { Constants } from "@shared/models/constants";
import { DataSharingLTE } from "@fs/services/data-sharing-lte";
import { DataSourceRequestState } from "@progress/kendo-data-query";
import { FSliteTradeService } from "@fs/services/trades";
import { FormControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { ISubscription } from "rxjs/Subscription";
import { NotificationsService } from "@shared/services/notification";
import { PriceModel, PriceBucketModel } from "src/app/fs-lte/models/price-book/price-book.model";
import { SaItemModel } from "@fs/models/price-book/sa-item.model";
import { SpinnerService } from "src/app/shared/services/spinner.service";
import { TabOpenService } from "src/app/services/tab-open.service";
import { Tabs } from "src/app/enums/tab.enum";
import { SaItemService } from "src/app/fs-lte/services/price-book/sa-item/sa-item.service";
import { customJS } from "@fs/services/customjs";
import { ProductItemType } from "@fs/enums/common-enums";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { UploadAttachmentMetaModel } from '@fs/models/upload-attachment.modal';
declare var SimpleBar: any;

@Component({
  selector: 'sa-item-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
  providers: [FSliteTradeService, SaItemService]
})
export class SaItemCreateComponent implements OnInit, AfterViewInit {
  @Input() tabCounter: number;

  public FeaturesAndBenefits: FormControl = new FormControl("", Validators.required);
  private dataLoaderCount = 2;
  private destroyTab: boolean = false;
  private subscriptions: ISubscription[] = [];
  public categories = [];
  private categoryHashTable: any = {};  
  public chkAllowDescEd: string;
  public chkAllowPriceEd: string;
  public chkIsFreqUsed: string;
  public chkIsTaxable: string;
  public formType = "New";
  public initialData: any;
  public inputParams: any;
  public isUnsavedTriggered: boolean = false;
  public itemImageSrc: string = '';
  public defaultSaImage = Constants.DefaultImagePaths.ServiceAgreementItem;
  public qbVersion: string = "";
  public searchStringMaterial: string = "";
  public serviceDetailData: SaItemModel;
  public serviceItemForm: FormGroup;
  public state: DataSourceRequestState = { skip: 0, take: -1, sort: [] };
  public tabId: number = Tabs.FsLiteServiceAgreementItem;
  saCategories = [];
  productItemType = ProductItemType;
  overlay: boolean = false;
  protected readonly ngUnsubscribe$ = new Subject();
  attachmentMetaData: UploadAttachmentMetaModel;
  constructor(
    private frmbuilder: FormBuilder,
    private dataSharing: DataSharingLTE,
    private tabOpen: TabOpenService,
    private commonMethods: CommonMethods,
    private toastr: NotificationsService,
    private $elementRef: ElementRef,
    private zone: NgZone,
    private httpSaItem: SaItemService,
    private httpCommon: CommonService,
    private auth: AuthService,
    private fSliteTradeService: FSliteTradeService,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef
  ) { this.setInitModels(); }

  //#region Life-cycle Events
  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    this.destroySubscriptions();
  }
  ngOnInit() {
    this.itemImageSrc = this.defaultSaImage;
    this.httpCommon
      .GetIntialData(
        this.auth.getCompanyId(),
        "ServiceTypes,PriceBookAccountingCodes,PriceBuckets"
      )
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(response => {
        this.initialData = response;
      });
    this.CreateServiceItemForm();
    //#region Subscriptions
    let subscription = this.tabOpen.routeToParentEvent.subscribe(response => {
      if (
        response.tabCounter == this.tabCounter &&
        response.event.split("|")[0] == "replaceTab" &&
        response.event.split("|")[1] == "discard"
      ) {
        $(this.$elementRef.nativeElement)
          .find(".tabs__content__box")
          .removeClass("dirty");
        this.CheckAndReplace();
        this.destroySubscriptions();
      } else if (
        response.tabCounter == this.tabCounter &&
        response.event.split("|")[0] == "replaceTab" &&
        response.event.split("|")[1] == "save"
      ) {
        this.CreateServiceItem();
      }
    });
    this.subscriptions.push(subscription);
    subscription = this.tabOpen.ConfirmDestroyTabEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter) {
        this.destroyTab = true;
        this.CreateServiceItem();
      }
    });
    this.subscriptions.push(subscription);

    subscription = this.tabOpen.ChangeComponentEvent.subscribe(response => {
      if (response.removeSubscriptions != undefined) {
        if (response.removeSubscriptions) {
          this.destroySubscriptions();
        }
      }
    })
    this.subscriptions.push(subscription);
    //#endregion

    this.GetTrades();
    this.qbVersion = (this.auth.getCompanyQBType()).toLowerCase();
    //#region Generate random Ids for controls
    this.chkIsFreqUsed = "ChkFreqUsed_" + CommonMethods.GenerateRandomID();
    this.chkAllowDescEd = "ChkAllDescEd_" + CommonMethods.GenerateRandomID();
    this.chkIsTaxable = "ChkIsTaxable" + CommonMethods.GenerateRandomID();
    //#endregion
    if (this.inputParams != undefined && this.inputParams.ID != undefined) {
      this.formType = "Edit";
      this.GetServiceAgreementItem();
      this.HideDataLoader();
    } else {
      this.HideDataLoader();
      this.onChanges();
    };
  }
  ngAfterViewInit() {
    this.commonMethods.ApplyMaxLengthForKendoNumericBox(16);
  }
  ngDoCheck() {
    if (!this.isUnsavedTriggered) {
      let isDirty = this.serviceItemForm.dirty;
      if (isDirty) {
        this.isUnsavedTriggered = true;
        this.tabOpen.unsavedChangedDetected({
          dirty: isDirty,
          Index: this.tabCounter
        });
      }
    }
  }
  //#endregion

  //#region Private Methods
  setInitModels() {
    this.attachmentMetaData = {
        attachments: [],
        externalUrl: 'pricebook/externalserviceagreementitemsattachment',
        showAttachment: false,
        uploadUrl: 'pricebook/serviceagreementitemsattachment',
        deleteItem: null
    };
  }
  private destroySubscriptions() {
    this.subscriptions.forEach(element => {
      element.unsubscribe();
    });
  }
  private GetTrades() {
    this.overlay = true;
    this.fSliteTradeService.fetch("", {}, "").pipe(takeUntil(this.ngUnsubscribe$)).subscribe(
      r => {
        this.categories = r.Children;
        this.saCategories = this.categories.filter(x => !x.IsSealed && x.IsVisible);
        this.categoryHashTable = this.buildIndexTree(this.saCategories);
        setTimeout(() => {
          this.serviceItemForm.controls["Category"].setValue(
            CommonMethods.CheckNullOrUndefined(this.serviceDetailData.Category)? "" : this.serviceDetailData.Category.ID);
          this.serviceItemForm.controls["ServiceAgreementCategories"].setValue(this.getCategoryIndexs(this.serviceDetailData.ServiceAgreementCategories));
          this.overlay = false;
        }, 100);
      },
      () => {
        this.overlay = false;
        this.HideDataLoader();
      }
    );
  }
  private GetServiceAgreementItem() {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    this.httpSaItem.GetSaItem(this.inputParams.ID).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(
      response => {
        this.HideDataLoader();
        this.serviceDetailData = response;
        if (!CommonMethods.CheckNullOrUndefined(response)) {
          if (!CommonMethods.CheckNullOrUndefined(response.PriceBookItem)) {
            this.serviceDetailData.IsFrequentlyUsed = response.PriceBookItem.IsFrequentlyUsed;
            this.serviceDetailData.IsDescriptionEditAllowed = response.PriceBookItem.IsDescriptionEditAllowed;
            this.serviceDetailData.IsTaxable = response.PriceBookItem.IsTaxable;
          }
          this.attachmentMetaData.attachments = response.Attachments.map(x => {
            const uploadedBy = x['UploadedBy'];
            x['UploadedByName'] = !CommonMethods.CheckNullOrUndefined(uploadedBy)? `${uploadedBy.FirstName} ${uploadedBy.LastName}` : "";
            x['checkIsNotImage'] = this.commonMethods.CheckLinkIsNotImage(x); 
            x['IsImage'] = !x['checkIsNotImage']; 
            return x;
          });

          this.itemImageSrc =
            this.attachmentMetaData.attachments.find(x => x.IsDefaultImage) != undefined
              ? this.attachmentMetaData.attachments.find(x => x.IsDefaultImage).FilePath
              : this.itemImageSrc;
          this.serviceDetailData.Attachments = this.attachmentMetaData.attachments;
        }
        this.CreateServiceItemForm();
        this.onChanges();
      },
      error => {
        this.HideDataLoader();
        if (!CommonMethods.CheckNullOrUndefined(error.error))
          this.toastr.showMultiLineError(error.error.Message, "Error");
      }
    );
  }
  private CreateServiceItemForm() {
    if (this.serviceDetailData == undefined || this.serviceDetailData.ID == undefined)
      this.serviceDetailData = new SaItemModel();
    
    this.serviceItemForm = this.frmbuilder.group({
      ID: new FormControl(this.serviceDetailData.ID),
      ItemNumber: new FormControl(
        this.serviceDetailData.ItemNumber,
        this.commonMethods.noWhitespaceValidator
      ),
      IsFrequentlyUsed: new FormControl(
        this.serviceDetailData.IsFrequentlyUsed
      ),
      Description: new FormControl(
        this.serviceDetailData.Description,
        this.commonMethods.noWhitespaceValidator
      ),
      Category: new FormControl(
        this.serviceDetailData.Category == null
          ? ""
          : this.serviceDetailData.Category.ID, Validators.required),
      AccountingCode: new FormControl(
        this.serviceDetailData.AccountingCode == null
          ? ""
          : this.serviceDetailData.AccountingCode.ID),
      Note: new FormControl(this.serviceDetailData.Note),
      StandardCost: new FormControl(
        this.serviceDetailData.Prices.length == 0
          ? 0
          : parseFloat(this.serviceDetailData.Prices[0].Amount), Validators.required),
      IsDescriptionEditAllowed: new FormControl(this.serviceDetailData.IsDescriptionEditAllowed),
      IsTaxable: new FormControl(this.serviceDetailData.IsTaxable),

      LengthOfContract: new FormControl(this.serviceDetailData.Length, Validators.required),
      Interval: new FormControl(this.serviceDetailData.IntervalType.Code, Validators.required),
      ServiceAgreementCategories: new FormControl(this.getCategoryIndexs(this.serviceDetailData.ServiceAgreementCategories)),
      FeaturesAndBenefits: new FormControl(this.serviceDetailData.FeaturesAndBenefits, Validators.required),
      Discount: new FormControl(this.serviceDetailData.Discount),

      DurationType: new FormControl(this.serviceDetailData.DurationType.Code, Validators.required),

      IsActive: new FormControl(true),
      Attachments: new FormControl(this.serviceDetailData.Attachments),
      ModifyDate: new FormControl()
    });
    this.FeaturesAndBenefits.setValidators(Validators.required);
    this.FeaturesAndBenefits.setValue(this.serviceDetailData.FeaturesAndBenefits);
  }
  private getCategoryIndexs(categories: any[]): string[] {
    let indexs: string[] = [];
    if (categories != null) {
      categories.forEach(element => {
        indexs.push(this.categoryHashTable[element]);
      });
    }
    return indexs;
  }
  private buildIndexTree(data): any {
    let resultObj = {};
    for (let i = 0; i < data.length; i++) {
      resultObj[data[i].ID] = i.toString();
      if (data[i].Children.length > 0) {
        for (let j = 0; j < data[i].Children.length; j++) {
          resultObj[data[i].Children[j].ID] = i.toString() + "_" + j.toString();
          if (data[i].Children[j].Children.length > 0) {
            for (let k = 0; k < data[i].Children[j].Children.length; k++) {
              resultObj[data[i].Children[j].Children[k].ID] = i.toString() + "_" + j.toString() + "_" + k.toString();
            }
          }
        }
      }
    }
    return resultObj;
  }
  private HideDataLoader() {
    this.dataLoaderCount = this.dataLoaderCount - 1;
    if (this.dataLoaderCount <= 0) {
      this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
      this.dataLoaderCount = 0;
    }
  }
  private CheckAndReplace() {
    if (this.serviceDetailData.ID != "") {
      this.tabOpen.ReplaceTab(
        {
          CurrentTabIndex: this.tabCounter,
          newTabInfo: {
            tabId: Tabs.FsLiteServiceAgreementItemDetail,
            params: { ID: this.serviceDetailData.ID },
            tabTitle: "Agreement - " + this.serviceDetailData.ItemNumber
          }
        },
        true
      );
    } else {
      this.tabOpen.DestroyTab(this.tabCounter);
      this.tabOpen.OpenTab({
        tabId: Tabs.FsLitePriceBookList,
        params: {},
        tabTitle: "Products"
      });
    }
  }
  //#endregion

  //#region Public Methods  
  public CreateServiceItem() {
    if (
      this.serviceItemForm.valid && this.FeaturesAndBenefits.valid) {
      let submitModel: SaItemModel = new SaItemModel();
      submitModel.ID = this.serviceItemForm.value.ID;
      submitModel.ItemNumber = this.serviceItemForm.value.ItemNumber;
      submitModel.Description = this.serviceItemForm.value.Description;
      submitModel.IsFrequentlyUsed = this.serviceItemForm.value.IsFrequentlyUsed;
      submitModel.Category = { ID: this.serviceItemForm.value.Category };

      if (this.serviceDetailData.Prices.length > 0) {
        submitModel.Prices[0] = this.serviceDetailData.Prices[0];
        submitModel.Prices[0].ID = this.serviceDetailData.Prices[0].ID;
        submitModel.Prices[0].Amount = this.serviceItemForm.value.StandardCost;
        submitModel.Prices[0].IsDirty = true;
      } else if (this.initialData.PriceBuckets.length > 0) {
        let priceBuckets = this.initialData.PriceBuckets.filter(
          x => x.Name == "Standard"
        );
        let price = new PriceModel();
        let priceBucket = new PriceBucketModel();
        price.Amount = this.serviceItemForm.value.StandardCost;
        priceBucket.ID = priceBuckets != null ? priceBuckets[0].ID : "";
        price.Bucket = priceBucket;
        submitModel.Prices[0] = price;
      }

      if (this.serviceItemForm.value.AccountingCode != "")
        submitModel.AccountingCode = {
          ID: this.serviceItemForm.value.AccountingCode,
          Name: "",
          Description: ""
        };
      else submitModel.AccountingCode = null;
      submitModel.Note = this.serviceItemForm.value.Note;
      submitModel.IsDescriptionEditAllowed = this.serviceItemForm.value.IsDescriptionEditAllowed;
      submitModel.IsTaxable = this.serviceItemForm.value.IsTaxable;
      submitModel.Length = this.serviceItemForm.value.LengthOfContract;
      submitModel.DurationType = this.commonMethods.getCompany().CodeTypeData.DurationType.find(x => (x.Code == this.serviceItemForm.value.DurationType));
      submitModel.IntervalType = this.commonMethods.getCompany().CodeTypeData.VisitIntervalType.find(x => x.Code == this.serviceItemForm.value.Interval);
      submitModel.ServiceAgreementCategories = this.buildResultArray(this.serviceItemForm.value.ServiceAgreementCategories);
      submitModel.Discount = this.serviceItemForm.value.Discount == null ? 0:  this.serviceItemForm.value.Discount;
      submitModel.FeaturesAndBenefits = this.FeaturesAndBenefits.value;
      const attachments = Object.assign([], this.attachmentMetaData.attachments);
      attachments.forEach(x => {
        delete x.UploadedBy;
      });
      submitModel.Attachments = attachments;
      submitModel.ModifyDate = this.serviceDetailData.ModifyDate;
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
      if (!CommonMethods.CheckNullOrUndefined(submitModel.ID, true)) {
        this.httpSaItem.SaveEditSaItem(submitModel).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(
          () => {
            if (
              $(this.$elementRef.nativeElement)
                .find(".tabs__content__box")
                .hasClass("dirty")
            ) {
              $(this.$elementRef.nativeElement)
                .find(".tabs__content__box")
                .removeClass("dirty");
            }
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);

            this.dataSharing.ItemChangeEvent();
            setTimeout(() => {
              if (this.destroyTab) {
                this.tabOpen.DestroyTab(this.tabCounter);
              } else {
                this.tabOpen.ReplaceTab({
                  CurrentTabIndex: this.tabCounter,
                  newTabInfo: {
                    tabId: Tabs.FsLiteServiceAgreementItemDetail,
                    params: { ID: submitModel.ID },
                    tabTitle: "Agreement - " + submitModel.ItemNumber
                  }
                });
              }
            }, 300);
            this.destroySubscriptions();
            this.toastr.success(
              "Service Agreement item " + submitModel.ItemNumber + " updated",
              "Success!"
            );
          },
          error => {
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            if (!CommonMethods.CheckNullOrUndefined(error.error))
              this.toastr.showMultiLineError(error.error.Message, "Error");
          }
        );
      } else {
        this.httpSaItem.SaveSaItem(submitModel).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(
          response => {
            if (
              $(this.$elementRef.nativeElement)
                .find(".tabs__content__box")
                .hasClass("dirty")
            ) {
              $(this.$elementRef.nativeElement)
                .find(".tabs__content__box")
                .removeClass("dirty");
            }
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            this.toastr.success(
              "Service Agreement item " + submitModel.ItemNumber + " created",
              "Success!"
            );
            this.dataSharing.ItemChangeEvent();
            //setTimeout(() => {
            if (this.destroyTab) {
              this.tabOpen.DestroyTab(this.tabCounter);
            } else {
              this.tabOpen.ReplaceTab({
                CurrentTabIndex: this.tabCounter,
                newTabInfo: {
                  tabId: Tabs.FsLiteServiceAgreementItemDetail,
                  params: { ID: response.ID },
                  tabTitle: "Agreement - " + submitModel.ItemNumber
                }
              });
            }
            // }, 300);
            this.destroySubscriptions();
          },
          error => {
            this.destroyTab = false;
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            if (!CommonMethods.CheckNullOrUndefined(error.error))
              this.toastr.showMultiLineError(error.error.Message, "Error");
          }
        );
      }
    } else {
      this.destroyTab = false;
      this.commonMethods.markFormGroupTouched(this.serviceItemForm);
      this.FeaturesAndBenefits.markAsTouched();
      this.zone.runOutsideAngular(() => {
        customJS.verifyBoxes(this.$elementRef.nativeElement);
      });
    }
  }
  private onChanges() {
    this.subscriptions.push(this.FeaturesAndBenefits.valueChanges.subscribe(val => {
      this.serviceItemForm.controls['FeaturesAndBenefits'].patchValue(val);
      this.serviceItemForm.controls['FeaturesAndBenefits'].updateValueAndValidity();
      this.serviceItemForm.markAsDirty();
    }));
  }
  private buildResultArray(checkedKeys: string[]) {
    let resultArray: string[] = [];
    checkedKeys.forEach(e => {
      if (!CommonMethods.CheckNullOrUndefined(e)) {
        let keyIndexes = e.split('_');

        if (keyIndexes.length == 1) { //Trade
          let tradeNode = this.saCategories[parseInt(keyIndexes[0])];
          resultArray.push(tradeNode.ID);
        }
        else if (keyIndexes.length == 2) { // Category
          let categoryNode = this.saCategories[parseInt(keyIndexes[0])].Children[parseInt(keyIndexes[1])];
          resultArray.push(categoryNode.ID);
        } else if (keyIndexes.length == 3) { // Sub Category
          let subCategoryNode = this.saCategories[parseInt(keyIndexes[0])].Children[parseInt(keyIndexes[1])].Children[parseInt(keyIndexes[2])];
          resultArray.push(subCategoryNode.ID);
        }
      }
    });
    return resultArray;
  }
  public OnExpand() {
    $(document).on("click", ".k-hierarchy-cell>a", function () {
      $(this)
        .parents(".k-master-row")
        .addClass("active");
    });
  }
  public OnCollapse() {
    $(document).on("click", ".k-hierarchy-cell>a", function () {
      $(this)
        .parents(".k-master-row")
        .removeClass("active");
    });
  }
  public ReIntializeMaterialScroll() {
    this.zone.runOutsideAngular(() => {
    });
  }
  public CancelAction() {
    if (this.serviceDetailData.ID != "") {
      this.tabOpen.ReplaceTab({
        CurrentTabIndex: this.tabCounter,
        newTabInfo: {
          tabId: Tabs.FsLiteServiceAgreementItemDetail,
          params: { ID: this.serviceDetailData.ID },
          tabTitle: "Agreement - " + this.serviceDetailData.ItemNumber
        }
      });
    } else {
      this.tabOpen.DestroyTab(this.tabCounter);
    }
  }
  public documentData(data: GridDataResult) {
    this.serviceItemForm.markAsDirty();
    this.serviceItemForm.updateValueAndValidity();
    this.attachmentMetaData.attachments = data.data;
    this.serviceItemForm.controls['Attachments'].patchValue(data);
  }
  public updateItemImage(imagePath: string) {
    if (imagePath == '')
      this.itemImageSrc = this.defaultSaImage;
    else this.itemImageSrc = imagePath;
  }
  //#endregion
}